/**
 * @generated SignedSource<<4fd2ebe7aaa9d4dbf813a8ccd2b8ef5d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Row345BadPattern$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"Row405BadPattern" | "Row73BadPattern">;
  readonly " $fragmentType": "Row345BadPattern";
};
export type Row345BadPattern$key = {
  readonly " $data"?: Row345BadPattern$data;
  readonly " $fragmentSpreads": FragmentRefs<"Row345BadPattern">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "isDensityFull",
    "variableName": "isDensityFull"
  },
  {
    "kind": "Variable",
    "name": "isRemoteLinkedIssuesEnabled",
    "variableName": "isRemoteLinkedIssuesEnabled"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isDensityFull"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isRemoteLinkedIssuesEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "Row345BadPattern",
  "selections": [
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "Row73BadPattern"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "Row405BadPattern"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    }
  ],
  "type": "JiraIssue"
};
})();

(node as any).hash = "80856252a6b051c45aa13863998d459d";

export default node;
